import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useListaCEPService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
// Icon

export const RecorteListaCEP = () => {
    // State
    const { listasCEP } = useAppSelector((state) => state.listaCEP)
    const { openForm, createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Use State
    const [selectedListaCEP, setSelectedListaCEP] = useState<number[]>([])

    // Hook
    const { setupListaCEP, resetListasCEP } = useListaCEPService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const listasCEPDoRedux = createRecorteExtracaoForm.fields.Filtros?.listasCEP || [];

        if (listasCEPDoRedux.length > 0) {
            setSelectedListaCEP(listasCEPDoRedux);
        } else {
            setSelectedListaCEP([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.listasCEP]);

    // Filtra as opções para remover os itens já selecionados
    const filteredListasCEP = (listasCEP || []).filter((lista) =>
        !selectedListaCEP.includes(lista.IdVelesGeoListaCEP)
    );

    const handleListaCEPSelectionChange = (value: any[]) => {
        const ids = (value || []).map((lista) => lista?.IdVelesGeoListaCEP || 0)
        setSelectedListaCEP(ids)

        if (ids.length > 0) {
            syncFilterWithForm({
                filtro: 'listasCEP',
                value: ids,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'listasCEP',
                formType: 'create'
            });
        }
    }

    // Use Effect
    useEffect(() => {
        setupListaCEP()
    }, [setupListaCEP])

    useEffect(() => {
        resetListasCEP()
    }, [openForm, resetListasCEP])

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredListasCEP}
                    getOptionLabel={(option) => option?.Nome?.toUpperCase() || ''}
                    sx={{ px: 2 }}
                    value={(listasCEP || []).filter(lista => selectedListaCEP.includes(lista.IdVelesGeoListaCEP))}
                    onChange={(event, value) => {
                        handleListaCEPSelectionChange(value);
                    }}
                    noOptionsText={'Nenhuma lista encontrada'}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Listas de CEPs"
                        />
                    )}
                />
            </Grid>
        </>
    )
}